const getFaqsList = (t) => [
  {
    question: t("faqs.defaultQuestions.q1"),
    answer: t("faqs.defaultQuestions.a1"),
  },
  {
    question: t("faqs.defaultQuestions.q2"),
    answer: t("faqs.defaultQuestions.a2"),
  },
  {
    question: t("faqs.defaultQuestions.q3"),
    answer: t("faqs.defaultQuestions.a3"),
  },
  {
    question: t("faqs.defaultQuestions.q4"),
    answer: t("faqs.defaultQuestions.a4"),
  },
  {
    question: t("faqs.defaultQuestions.q5"),
    answer: t("faqs.defaultQuestions.a5"),
  },
  {
    question: t("faqs.defaultQuestions.q6"),
    answer: t("faqs.defaultQuestions.a6"),
  },
  {
    question: t("faqs.defaultQuestions.q7"),
    answer: t("faqs.defaultQuestions.a7"),
  },
  {
    question: t("faqs.defaultQuestions.q8"),
    answer: t("faqs.defaultQuestions.a8"),
  },
  {
    question: t("faqs.defaultQuestions.q9"),
    answer: t("faqs.defaultQuestions.a9"),
  },
  {
    question: t("faqs.defaultQuestions.q10"),
    answer: t("faqs.defaultQuestions.a10"),
  },
  {
    question: t("faqs.defaultQuestions.q11"),
    answer: t("faqs.defaultQuestions.a11"),
  },
  {
    question: t("faqs.defaultQuestions.q12"),
    answer: t("faqs.defaultQuestions.a12"),
  },
];

export default getFaqsList;
